import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { FLAG_ACTION_TYPE } from "./flag.action";
import { Flag, FlagState } from "./flag.model";
import { FlagUtil } from "./flag.util";

const initialState: FlagState = {
	isBusy: false,
	initialFlags: [],
	flags: [],
};

export function flagReducer(state = initialState, action: ActionWithPayload): FlagState {
	switch (action.type) {
		case FLAG_ACTION_TYPE.getAll: {
			return updateState(state, {
				isBusy: true,
			});
		}
		case FLAG_ACTION_TYPE.getAllSuccess: {
			return updateState(state, {
				initialFlags: action.payload as Flag[],
				isBusy: false,
			});
		}
		case FLAG_ACTION_TYPE.getAllFail: {
			return updateState(state, {
				isBusy: false,
			});
		}
		case FLAG_ACTION_TYPE.updateSuccess: {
			return updateState(state, {
				flags: action.payload as Flag[],
			});
		}
		case FLAG_ACTION_TYPE.setCurrent: {
			return updateState(state, {
				currentFlag: action.payload as Flag,
			});
		}
		case FLAG_ACTION_TYPE.appendRouteParams: {
			const updatedFlags = FlagUtil.appendRouteParamsToFlags(state.flags, action.payload);
			return updateState(state, {
				flags: updatedFlags,
			});
		}
		default:
			return state;
	}
}
